const createStatusObj = (status, active) => {
    let color = ''
    let backgroundColor = ''
    if (status == 'prospecto') {
        color = '#FFA310'
        backgroundColor = '#FFE4B9BF'
    } else
        if (status == 'conectado') {
            color = '#28AF00'
            backgroundColor = '#25B61546'
        } else
            if (status == 'asignado') {
                color = '#1EA5CB'
                backgroundColor = '#C4FEFFA3'
            } else {
                color = '#696776'
                backgroundColor = '#E1E1E1'
            }
            
    return {
        name: status.toUpperCase(),
        color,
        backgroundColor
    }
}

export const parseConnectionPoints = (connectionPoints) => {
    return connectionPoints.map((connectionPoint) => ({
        id: connectionPoint.id,
        idRedJalisco: connectionPoint.id_red_jalisco,
        name: connectionPoint.name,
        status: createStatusObj(connectionPoint.status, connectionPoint.active),
        active: connectionPoint.active,
        project: connectionPoint.last_proyect != null ? connectionPoint.last_proyect.name : 'Sin información',
        thematic: connectionPoint.thematic.thematic,
        clasification: connectionPoint.clasification.clasification,
        municipality: connectionPoint.municipality.name,
        updatedAt: connectionPoint.updated_at
    }))
}
